/* eslint-disable jsx-a11y/control-has-associated-label */
import classnames from 'classnames';
import _ from 'lodash';
import arrowLeftIcon from '@/shared/ui/icons/Components/arrow-left-icon.svg';
import arrowRightIcon from '@/shared/ui/icons/Components/arrow-right-icon.svg';
import useEventSelection from './useEventSelection';
import './styles.scss';

const EVENT_SELECTION_CLASS_NAME: Record<string, string> = {
  AFIB: '--afib-event',
  ARTIFACT: '--artifact-event',
  MINUTE_INFO: '--minute-info-event',
};

export type EventSelectionProps = {
  onClick?: (index: number) => void;
  selectedEventIndex?: number;
  // PropTypes.shape() with no shape — component relies on lodash's _.map which
  // iterates both arrays and plain objects, hence the object default below.
  data?: any;
  selectedEvent?: { type?: string };
  componentId?: string;
};

const EventSelection = ({
  onClick = () => {},
  selectedEventIndex = 0,
  data = {},
  selectedEvent = {},
  componentId = '',
}: EventSelectionProps) => {
  const { sideScroll } = useEventSelection({ componentId, data, selectedEventIndex });

  return (
    <div
      className={classnames(
        'event-selected-info-tab-wrapper',
        selectedEvent?.type
          ? EVENT_SELECTION_CLASS_NAME[selectedEvent?.type] || '--base-event'
          : '',
      )}
    >
      <button
        onClick={() => sideScroll('left')}
        className={classnames('event-scroll-btn --left-arrow', componentId)}
      >
        <img src={arrowLeftIcon} alt="" />
      </button>
      <div className={classnames('event-selected-info-tab', componentId)} id="scroll-container">
        {_.map(data, (item: any) => {
          const { titleFormat, index, type } = item;
          return (
            <button
              id={`event-selection-tab-${index}`}
              className={classnames(
                'tab-item',
                EVENT_SELECTION_CLASS_NAME[type] || '--event',
                index === selectedEventIndex ? '--active' : '',
              )}
              onClick={() => {
                if (index !== selectedEventIndex) {
                  onClick(index);
                }
              }}
            >
              {titleFormat}
            </button>
          );
        })}
      </div>
      <button
        onClick={() => sideScroll('right')}
        className={classnames('event-scroll-btn --right-arrow', componentId)}
      >
        <img src={arrowRightIcon} alt="" />
      </button>
    </div>
  );
};

export default EventSelection;
